import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { model, appqrcodeurl, wfqrcodeurl } from '../config/config';


export default function AppCardDetails({ children, name, fileid, imgurl, zipurl, author, desc }) {
  const [open, setOpen] = React.useState(false);
 
  const navigate = useNavigate();
	const handleClose = () => {
	navigate(-1)
  };
  
  let wfheight = 0;
	if( model.includes("gtr4") || model.includes("balance") || model.includes("active"))
	{
		wfheight = 180;
	}else{
		wfheight = 300;
	}
	
    var qrmodel = ["gtr4","balance","active"];
	var modelid = ["7930112","8519936","8323328"];
	
   const  selectedAppCardId  = JSON.parse(localStorage.getItem("selectedAppCard"));
   const  filetype  = localStorage.getItem("filetype");
	
	var name = selectedAppCardId.name;
	var fileid = selectedAppCardId.fileid;
	var zipurl = selectedAppCardId.zipurl;
	var imgurl = selectedAppCardId.imgurl;
	var author = selectedAppCardId.author;
	var desc = selectedAppCardId.desc;
	
  const downloadFilenew = () => {
 
	window.location.href =  `${zipurl}`;
	 
  }
  
 

  React.useEffect(() => {
   // fetchData();
  
  }, []);
  

	
  return (
    <div className='parent-modal'>
      
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>

            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {name}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        
          <div className='modal'>
            <div className='modal-left'>
			
              <img src={imgurl} alt={name}  height = {`${wfheight}`} />
            </div>
            <div className='modal-right'>

              <div className='title'>
                <Typography gutterBottom variant="h4" component="h4">
                  <span>{name} by {author}</span>
                </Typography>					
              </div>

              <div className='overview'>
                <Typography gutterBottom variant="h6" component="h6" mt={4}>
				Supported watch : Amazfit {model.toUpperCase()}
                </Typography>
                <Typography gutterBottom variant="h8" component="h4" mt={4}>
				Description : {desc}
                </Typography>
				
				<br/>
              </div>
			   <div className='download'>
			   <Button variant="contained" onClick={() => downloadFilenew()}>Download</Button>
			   
				</div>
            </div>
			
			
			{ filetype === "apps" ? 
					( <div className='qrcode' style={{marginRight: 100, marginTop: 30}}  >
								 
									QR Code for installation through Zepp 'Scan' option <a href="/scanguide" style={{color : '#FF0000'}}>help</a>

									<br/>
								  <br/>
								<img src={ `${appqrcodeurl}${zipurl.replace("https","")}` } />	
						</div>)
				   :
				   qrmodel.includes(model) ?
				   ( <div className='qrcode' style={{marginRight: 100, marginTop: 30}}  >
								 
									QR Code for installation through Zepp 'Scan' option <a href="/scanguide" style={{color : '#FF0000'}}>help</a>

									<br/>
								  <br/>
								<img src={  `${wfqrcodeurl}${model}/${model}_${fileid}.zpk` } />	
						</div>)
					:	
				   (
				   <div className='qrcode'>
				   </div>
				   )
			}	
				  
			
          </div>
        
      
    </div>
  );
}
